module.exports = __webpack_public_path__ + "img/circus.4bfff5f9.png";